<template>
    <div>
        <div class="modal-container has-text-centered">
            <div v-if="!promptToComplete && showIt" class="notification">
                <button id="xButt" class="delete" @click="$emit('close')"></button>
                <div id="title" class="bottom10 top30"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3"> PUBLIC OR PRIVATE</span></div> 
                <div>This bundle is currenlty <b>{{isPublic ? 'public' : 'private'}}</b>.</div>
                <div class="top10 alertMessage is-size-5">Make this bundle {{isPublic ? 'private' : 'public'}}?</div>
                <div class="top20">(It will automatically {{isPublic ? 'be removed from' : 'appear in'}} your profile {{isPublic ? '' : 'for everyone to view'}})</div>
                <div class="top40">
                  
                    
                    <button class="button wideButton is-coolGreen" @click="ok">
                        OK
                    </button>
                    <br>
                    <div class="top10 cancelButton handCursor" @click="cancel">
                        Cancel
                    </div>

                    
                </div>
            </div>


            <div v-if="promptToComplete" class="notification">
                <button id="xButt" class="delete" @click="$emit('close')"></button>
                <div id="title" class="bottom10 top30"><span class="dot4"><b>::</b></span>Public or Private</div> 
                <div class="bottom20">Please complete your public profile before making any bundles public. Select 'Profile' from the 'My Account' menu.</div>
               
                    <button class="button wideButton is-coolGreen" @click="ok">
                        OK
                    </button>
                    <br>
                <!--     <div class="top10 cancelButton handCursor" @click="cancel">
                        Cancel
                    </div> -->

                    
             </div>
        
        </div>
    </div>
</template>

<script>
export default {
  props: {id: Number, isPublic: Boolean},
  data: function(){
      return {
          promptToComplete: false,
          showIt: false
      }
  },
  mounted: function(){
       var self = this;
       if(!self.$root.app.userAttrs.profile){
           //check for profile
           function w(d){
               if(d == 'no'){
                    //prompt to complete profile
                    self.promptToComplete = true
               } else {
                   self.showIt = true
               }
           }
           function n(){
               
           }

           this.$root.app.apiClient.get('subs/data/profileexists', {}, w, n)
       } else {
           self.showIt = true
       }
  },
  methods: {
      ok: function(){

        var self = this;

       

        function w(d){
            if(d.r){
                let b = self.$root.app.bundles.find(e => {
                    let i = e.aliasTgtId || e.id
                    return i == self.id
                })
                b.isPublic = !self.isPublic
            }
        }  

        function n(){

        }

        this.$root.app.apiClient.put('subs/data/pubbundle', {id: this.id, action: !this.isPublic}, w, n)
         


        this.$emit('close')
      },
      cancel: function(){
          this.$emit('close')
      }
  }
}
</script>

<style scoped>
    #title{
        font-size: 1.5rem;
    }
    .modal-container{
        width: 350px;
        max-height: 350px;
    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
   

</style>
